import { render, staticRenderFns } from "./AccountSettingsInfo.vue?vue&type=template&id=fa3c303e"
import script from "./AccountSettingsInfo.vue?vue&type=script&lang=js"
export * from "./AccountSettingsInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports